<!-- Start Main Banner Area -->
<div class="main-banner-area" style="background-image: url({{image}});">
    <div class="container">
    </div>
</div>
<!-- End Main Banner Area -->